// Sentry initialization for GlobalEyes.TV
// JS error capture via @sentry/react only. Native (Swift/Kotlin) crash
// capture lives in @sentry/capacitor and is on the Slice D roadmap.
// DSN read from REACT_APP_SENTRY_DSN. No-op in dev unless
// REACT_APP_SENTRY_DSN_DEV=1.

import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN;
const ENABLE_IN_DEV = process.env.REACT_APP_SENTRY_DSN_DEV === '1';
const IS_PROD = process.env.NODE_ENV === 'production';

export const initSentry = () => {
  if (!DSN) return;
  if (!IS_PROD && !ENABLE_IN_DEV) return;

  Sentry.init({
    dsn: DSN,
    release: `globaleyes-tv@${process.env.REACT_APP_VERSION || 'unknown'}`,
    environment: IS_PROD ? 'production' : 'development',
    tracesSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
      'Failed to fetch',
      'Load failed',
    ],
  });
};

export { Sentry };
